// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export interface Version {
    version: string;
    branch: string;
    hash: string;
    buildAt: string;
    [K:string]: string|boolean|null;
}
export const VERSION = {
    "dirty": true,
    "raw": "b8ffa9d-dirty",
    "hash": "b8ffa9d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b8ffa9d-dirty",
    "semverString": null,
    "version": "1.23.4",
    "buildAt": "2026-11-04T19:45:53.135Z",
    "branch": "HEAD"
};
/* tslint:enable */
